<!--
* @description 诉求量分析
* @fileName demand.vue
* @author xuesong
* @date 2022/02/08 11:17:51
!-->
<template>
  <div id="demand">
    <div class="item-wrapper">
      <div class="item">
        <div class="item-left">
          <img
            src="@/assets/cockpit/demand.png"
            alt=""
            style="width: 50px; height: 50px"
          />
        </div>
        <div class="item-right">
          <div class="number">
            <countTo
              :startVal="0"
              :endVal="2017"
              :decimals="0"
              :duration="1500"
            />
          </div>
          <div class="label">已回复处理</div>
        </div>
      </div>
      <div class="item">
        <div class="item-left">
          <img
            src="@/assets/cockpit/demand.png"
            alt=""
            style="width: 50px; height: 50px"
          />
        </div>
        <div class="item-right">
          <div class="number">
            <countTo
              :startVal="0"
              :endVal="2123"
              :decimals="0"
              :duration="1500"
            />
          </div>
          <div class="label">诉求总和</div>
        </div>
      </div>
      <div class="item">
        <div class="item-left">
          <img
            src="@/assets/cockpit/demand.png"
            alt=""
            style="width: 50px; height: 50px"
          />
        </div>
        <div class="item-right">
          <div class="number">
            <countTo
              :startVal="0"
              :endVal="106"
              :decimals="0"
              :duration="1500"
            />
          </div>
          <div class="label">流转交办(条)</div>
        </div>
      </div>
      <div class="item">
        <div class="item-left">
          <img
            src="@/assets/cockpit/demand.png"
            alt=""
            style="width: 50px; height: 50px"
          />
        </div>
        <div class="item-right">
          <div class="number">
            <countTo
              :startVal="0"
              :endVal="95"
              :decimals="0"
              :duration="1500"
            />%
          </div>
          <div class="label">办结率</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import countTo from 'vue-count-to'
export default {
  name: 'Demand',
  components: { countTo }
}
</script>
<style lang='scss' scoped>
#demand {
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  .item-wrapper {
    box-sizing: border-box;
    // padding-top: 20px;
    padding-left: 0.2rem;
    width: 100%;
    height: 100%;
    display: flex;
    flex-wrap: wrap;
    .item {
      display: flex;
      margin-right: 0.4rem;
      align-items: center;
      margin-top: 0.4rem;
      .item-left {
        line-height: 0.5rem;
      }
      .item-right {
        margin-left: 0.1rem;
        height: 0.5rem;
        width: 1rem;
        .number {
          line-height: 0.25rem;
          font-size: 0.24rem;
          color: #fff;
          font-family: 'DINAlternate-Bold';
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          margin-bottom: 0.05rem;
        }
        .label {
          line-height: 0.25rem;
          font-size: 0.14rem;
          color: rgba(255, 255, 255, 100);
        }
      }
    }
  }
}
</style>
